import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-name-screening-report',
  templateUrl: './name-screening-report.component.html',
  styleUrls: ['./name-screening-report.component.scss']
})
export class NameScreeningReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
